import React, { Component } from 'react';
import 'babel-polyfill'; // to avoid - symbol is undefined error in IE
import { Tooltip } from 'reactstrap';

class TextWithTooltip extends Component {
  constructor(props) {
    super(props);
    this.state = { tooltipOpen: false };
  }

  toggle = () => {
    this.setState({ tooltipOpen: !this.state.tooltipOpen });
  };

  render() {
    const {
      icon,
      text,
      toolTipText,
      textClassName,
      labelText,
      id,
      Content,
    } = this.props;

    const { tooltipOpen } = this.state;

    return (
      <div className="text-with-tooltip">
        {labelText && (
          <div className="label">
            {labelText}
          </div>
        )}
        <div className={textClassName}>
          { icon &&
            <button id={id}>
              <i className={`td-icon icon-${icon}`} />
            </button>
          }
          <button id={id}>{text}</button>
          <Tooltip
            isOpen={tooltipOpen}
            target={id}
            toggle={this.toggle}
            className="custom-tool-tip"
            placement="auto"
            trigger="focus click hover"
          >
            { Content
              ? <Content />
              : <p className="tool-tip-text">{toolTipText}</p>
            }
          </Tooltip>
        </div>
      </div>
    );
  }
}

export default TextWithTooltip;
